Librarian.Window.TreeActionWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["onSubmitClicked"],

    options: {
        id: "treeActionWindow",
        treeContainer: "treeViewCtrl",
        width: 360,
        height: 385,
        title: null,
        catType: null
    },

    selectedNode: null,
    treeView: null,
    onSubmit: null,

    initialize: function(options) {
        this.setOptions(options);

        if (options && (typeof options.onSubmit == "function"))
            this.onSubmit = options.onSubmit;

        // Set the title on init so that we can use the localization
        if ((this.options.title || '').trim().length == 0)
            this.options.title = Librarian.Lang.getString("treeaction_title");

        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/treeactionwindow.html";

        this.parent(this.options);
    },

    reset: function() {
        var contEl = this.getElement(this.options.treeContainer);
        if (!contEl)
            return;

        // Empty the tree container so we don't get duplicates
        contEl.empty();
        var method = "getvpcc",
            rootMethod = "getvpci",
            rootCat = "-1";
        if (this.options.catType < 0)
            this.options.catType = Librarian.catType.myFavorite;
        else if (this.options.catType == Librarian.catType.file) {
            method = "getcc";
            rootMethod = "getci";
        }
        else if(this.options.catType == Librarian.catType.uploads){
            method = "getcc";
            rootMethod = "getci";
            rootCat = Librarian.specialCategories.UserUploads;
        }

        var options = {
            container: contEl.id,
            method: method,
            rootMethod: rootMethod,
            cookieStorage: false,
            catType: this.options.catType,
            rootCat: rootCat
        };

        if (typeof Library.getTreeOptions == "function")
            options = Library.getTreeOptions(options);

        this.treeView = new Librarian.TreeView(options);
        this.treeView.addEvent("select", function(node) {
            if (!node || !node.type.contains("file"))
                return;
            Librarian.Utils.setElementValue(this.getElement("selectedName"), node.name);
            this.selectedNode = node;

        }.bind(this));
        this.treeView.load();
    },

    onSubmitClicked: function() {
        if (!this.selectedNode) {
            Librarian.Utils.error("No file has been selected");
            return;
        }

        if (this.onSubmit && (typeof this.onSubmit == "function"))
            this.onSubmit(this.selectedNode.data);

        this.close();
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("treeActionSubmit");
        // Add the onClick and the correct label for the "save" button
        if (itemEl)
            itemEl.addOnClick(this.onSubmitClicked);

        itemEl = this.getElement("treeActionCancel");
        // If the cancel button is there, add the onclick method
        if (itemEl)
            itemEl.addOnClick(this.close);
        this.reset();
    }
});